import { Component, ViewChild, TemplateRef, ElementRef, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { messageService } from 'src/app/message.service';
import { qmsService } from '../qms.service';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { PaginationService } from 'src/app/PaginationService';
import { DynamicAuditTrailComponent } from 'src/app/support/dynamic-audit-trail/dynamic-audit-trail.component';
import { ExcelPdfComponent } from 'src/app/support/excel-pdf/excel-pdf.component';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { GridReorderComponent } from 'src/app/grid-reorder/grid-reorder.component';
import { EditorComponent } from 'src/app/editor/editor.component';

export interface PopupData {
  title: string;
}

@Component({
  selector: 'app-ccp',
  templateUrl: './ccp.component.html',
  styleUrls: ['./ccp.component.scss']
})

export class CcpComponent implements OnInit {

  isProcessing = true;
  ccpData: any = {};
  productCountries: any = {};
  listOfCountries: any = {};
  dateCustomClasses: DatepickerDateCustomClasses[];
  event = {
    isUserInput: true,
    source: {
      _selected: true,
    }
  };

  selectedProduct: any = null;
  selectedCountry: any = null;
  selectedLocations: any = [];

  dropDownForProduct: any = [];
  dropDownForCountry: any = [];
  dropDownForLocations: any = [];
  listOfLocationsFromLocationMaster: any = [];

  productDropDown: any = [];
  countryDropDown: any = [];
  locationsDropDown: any = [];

  showProductIfOthers: boolean;
  showLocationIfOthers: boolean;
  warningMsg: boolean;

  productSearchText: string = '';
  countrySearchText: string = '';
  locationSearchText: string = '';

  oddProduct: any = null;
  oddCountry: any = null;
  focusSearch(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value);
      searchBox?.focus();
    }, 0)
  }

  constructor(public dialog: MatDialog, private readonly appService: AppService, public router: Router, private readonly snackBar: MatSnackBar,
    public message: messageService, private readonly elem: ElementRef, public qmsService: qmsService, public paginationService: PaginationService) {
    const now = new Date();
    this.dateCustomClasses = [{ date: now, classes: ['bg-warning'] }];
  }

  htmlContent: any;
  @ViewChild(EditorComponent) editorComponent!: EditorComponent;
  getClobData(list: any, columnName: any) {
    this.isProcessing = true;
    let docObj = {

      primeIdentifier: list.PRIM_IDENTIFIER,
      tableView: list.tablevwname,
      columnName: columnName
    }
    this.htmlContent = "";
    this.appService.getClobToViewAudit(docObj).subscribe({
      next: (Response: any) => {
        this.htmlContent = Response.result;
        this.editorComponent.openEditor(this.htmlContent, columnName);
      }, error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
    this.isProcessing = false;
  }

  isFirstHalfFrozen: boolean = false;
  isSecondHalfFrozen: boolean = false;

  ngOnInit() {
    const userId = this.message.getUserId();
    const status = this.qmsService.activity.status;
    const isInvestigation = this.qmsService.activity.isInvestigationReqd;
    const ccHandler = this.qmsService.selectedGroupDetailData.activityHandler;
    const isEvaluator = this.qmsService.activity.evaluator == userId;
    const isInvestigator = this.qmsService.activity.evaluator == userId;

    this.appService.getQmsProductMasterVwDetails().subscribe((data: any) => {
      this.dropDownForProduct = data;
      this.selectBoxForProduct();
    })

    this.appService.getAllLocations().subscribe((location: any) => {
      this.listOfLocationsFromLocationMaster = location;
    })

    this.isFirstHalfFrozen = !this.message.showProductsActionButtons;
    this.isSecondHalfFrozen = !((ccHandler == 'Evaluator' || !isInvestigation) ? isEvaluator : isInvestigator) && (status == 'Pending Closure Review' || status == 'Closure Review Inprogress' || status == 'Pending Closure Approval' || status == 'Closure Approval Inprogress' || status == 'Closed' || status == 'In Progress');
    this.getCall();
  }

  label: any = [];
  dynamicLabel: any = null;
  dynamicLabelCall() {
    this.isProcessing = true;
    let data = {
      tableName: this.reportObj.tableOrViewName,
      moduleName: this.qmsService.moduleName,
      gridName: this.reportObj.gridName,
      groupId: this.qmsService.selectedGroup,
    };
    this.appService.getreorderGirdColumnList(data).subscribe({
      next: (labelResponse: any) => {
        this.label = labelResponse;
        this.dynamicLabel = this.label.reduce((acc: any, user: any) => {
          acc[`${user.columnName}`] = {
            fieldName: user.changedFieldName,
            isRemovable: user.isFieldRemovable,
            fieldNotes: user.fieldNotes
          };
          return acc;
        }, {});
        this.isProcessing = false;
      }, error: (error: any) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  singleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: false,
    allowSearchFilter: true,
    singleSelection: true,
    itemsShowLimit: 1,
    closeDropDownOnSelection: true,
  };

  multiSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: true,
    allowSearchFilter: true,
    singleSelection: false,
  };
  dateFormat: any = this.appService.organizationDetails?.dateFormat ?? 'DD-MMM-YYYY';
  commonDateConfig = {
    dateInputFormat: this.dateFormat,
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
  };

  manufacturedDateConfig = {
    ...this.commonDateConfig,
    maxDate: new Date(),
  }

  onManufacturedDateChange() {
    if (this.ccpData.expiryDate && (this.ccpData.manufacturedDate > this.ccpData.expiryDate)) this.ccpData.expiryDate = null;
  }

  generateExpiryDateConfig() {
    return {
      ...this.commonDateConfig,
      minDate: new Date(this.ccpData.manufacturedDate),
    };
  }

  sampleExpectedDateConfig = {
    ...this.commonDateConfig,
    minDate: new Date(),
  }

  sampleReceviedOnDateConfig = {
    ...this.commonDateConfig,
    minDate: new Date(),
  }

  onSampleReceivedOnDateChange() {
    if (this.ccpData.sampleReturnedOn && (this.ccpData.sampleReceivedOn > this.ccpData.sampleReturnedOn)) this.ccpData.sampleReturnedOn = null;
  }

  generateSampleReturnedOnDateConfig() {
    return {
      ...this.commonDateConfig,
      minDate: new Date(this.ccpData.sampleReceivedOn),
    };
  }

  selectBoxForProduct() {
    this.productDropDown = [];
    this.productDropDown = this.dropDownForProduct.map((item: { productId: any; productName: any; }) => ({
      valueExp: item.productId,
      displayExp: item.productName
    }));
  }

  private getNdc(productId: number): void {
    this.ccpData.ndc = this.dropDownForProduct.find((x: any) => x.productId == productId)?.ndc ?? null;
  }

  productName: any;
  onProductSelect(event: any, item: any): Promise<void> {

    return new Promise<void>((resolve, reject) => {

      if (event.isUserInput) {
        this.handleDropDownValidation('product-validation', item);

        if (item) {
          this.isProcessing = true;
          this.getNdc(+item.valueExp);
          [this.selectedCountry, this.selectedLocations, this.ccpData.productIfOthers, this.ccpData.country, this.ccpData.manufacturedLocationCode] = [null, [], "", "", ""];
          setTimeout(() => { this.showProductIfOthers = item.displayExp.toLowerCase() == 'others'; });
          this.appService.getProductCountriesDetailsByProductId(+item.valueExp).subscribe((productCountriesData: any) => {
            this.productCountries = productCountriesData;
            if (this.productCountries.length < 1 && !this.showProductIfOthers) {
              this.isProcessing = false;
              this.warningMsg = true;
              setTimeout(() => { this.productName = this.selectedProduct.toUpperCase() });
              this.countryDropDown = [];
              resolve();
            } else {
              if (this.warningMsg) this.warningMsg = false;
              this.appService.getNonOrgCodeListsByGroupName("COUNTRY").subscribe((countriesData: any) => {
                this.listOfCountries = countriesData;
                this.isProcessing = false;
                if (this.listOfCountries) {
                  this.dropDownForCountry = this.productCountries?.map((product: any) => this.listOfCountries?.find((country: any) => country.codelistCode == product.authorizationCountry));
                  resolve();
                  this.selectBoxForCountry();
                } else {
                  this.isProcessing = false;
                  resolve();
                }
              })
            }
          })
        } else {
          this.showProductIfOthers = false;
        }
      }
    });
  }

  onProductDeselect() {
    this.handleDropDownValidation('product-validation', this.selectedProduct);
    this.showProductIfOthers = false;
  }

  selectBoxForCountry() {
    this.countryDropDown = [];
    this.countryDropDown = this.dropDownForCountry.map((item: any) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    }));
  }

  onCountrySelect(event: any, item: any) {
    if (event.isUserInput) {
      if (item) {
        this.isProcessing = true;
        this.appService.getCountryLocationsByProductIdAndCountryCode(this.selectedProduct, item.valueExp).subscribe((response: any) => {
          this.isProcessing = false;
          let locationObj = response;
          if (locationObj) {
            this.isProcessing = true;
            this.dropDownForLocations = locationObj.listOfLocations?.split(',')?.map((splittedLocationId: any) => this.listOfLocationsFromLocationMaster?.find((location: any) => location.locationId == splittedLocationId))
            if (this.dropDownForLocations?.length > 0) {
              this.isProcessing = false;
              this.selectBoxForLocations();
            }
          }
        })
      } else {
        [this.selectedLocations, this.locationsDropDown] = [[], []];
      }
    }
  }

  onCountrySelectOld(item: any) {
    this.isProcessing = true;
    this.appService.getCountryLocationsByProductIdAndCountryCode(this.selectedProduct[0].valueExp,
      item.valueExp).subscribe((response: any) => {
        this.isProcessing = false;
        let locationObj = response;
        if (locationObj) {
          this.isProcessing = true;
          this.dropDownForLocations = locationObj.listOfLocations?.split(',')?.map((splittedLocationId: any) => this.listOfLocationsFromLocationMaster?.find((location: any) => location.locationId == splittedLocationId))
          if (this.dropDownForLocations?.length > 0) {
            this.isProcessing = false;
            this.selectBoxForLocations();
          }
        }
      })
  }

  onCountryDeSelect() {
    [this.selectedLocations, this.locationsDropDown] = [[], []];
  }

  selectBoxForLocations() {
    this.locationsDropDown = [];
    this.locationsDropDown = this.dropDownForLocations?.map((location: any) => ({
      valueExp: location.locationCode,
      displayExp: location.locationName
    }))
  }

  @ViewChild('locations') locations: MatSelect;
  locationsSelection = false;

  toggleAllSelection(value: any) {
    if (value == 'locations') {
      if (this.locationsSelection) this.locations.options.forEach((item: MatOption) => item.select());
      else {
        this.locations.options.forEach((item: MatOption) => item.deselect())
        this.selectedLocations = [];
      }
    }
  }

  onLocationSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        this.showLocationIfOthers = this.selectedLocations?.find((location: any) => 'others' == location.toLowerCase());
        this.locationsSelection = this.selectedLocations.length == this.locationsDropDown.length;
      })
    }
  }

  onLocationSelectOld() {
    this.showLocationIfOthers = this.selectedLocations?.find((location: any) => 'others' == location.displayExp.toLowerCase());
  }

  onLocationDeSelect() {
    this.showLocationIfOthers = this.selectedLocations[0].displayExp.toLowerCase().trim() == 'others';
  }

  onLocationSelectAll(item: any[]) {
    this.showLocationIfOthers = item?.find((location: any) => 'others' == location.displayExp.toLowerCase());
  }

  onLocationDeSelectAll(item: any[]) {
    this.showLocationIfOthers = false;
  }

  onIsSampleAvailableChange() {
    this.ccpData.isSampleReqd = false;
    this.onIsSampleRequestedChange();
  }

  onIsSampleRequestedChange() {
    this.ccpData.sampleExpectedDate = null;
    this.ccpData.sampleReceivedOn = null;
    this.ccpData.sampleReturnDecision = false;
  }

  onsampleReturnDecisionChange() {
    this.ccpData.sampleReturnedOn = null;
  }

  validateLotNumber(event: KeyboardEvent) {
    const charCode = event.key;
    const pattern = /^[a-zA-Z0-9 _]*$/;

    !pattern.test(charCode) && event.preventDefault();
  }

  handleDropDownValidation(fieldId: string, selectedItems: string | null) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    field.style.color = !selectedItems && field ? 'red' : '';
  }

  onNgModuleChange(items: any, fieldId: string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    field.style.color = items ? '' : 'red';
  }

  fieldValidation(elementIds: string[]) {
    elementIds.forEach((elementId) => {
      const element = document.getElementById(elementId) as HTMLInputElement;
      element.style.color = 'red';
    });
  }

  popupDataTitle: PopupData = {
    title: ''
  };

  popupTitle: string | null = 'title';
  @ViewChild('addAndEditPopup', { static: true }) addAndEditPopup: TemplateRef<any>;
  visibleAddAndEditPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('deletePopup', { static: true }) deletePopup: TemplateRef<any>;
  visibleDeletePopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('mandatoryPopup', { static: true }) mandatoryPopup: TemplateRef<any>;
  visibleMandatoryPopup: MatDialogRef<TemplateRef<any>>;

  addAndEditPopupConfig = {
    width: '75%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  deletePopupConfig = {
    width: '600px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  mandatoryPopupConfig = {
    width: '400px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  closeMandatoryPopup() {
    this.visibleMandatoryPopup.close();
  }

  visibleAddButton: boolean;
  visibleEditButton: boolean;
  operationFlag: any;

  openAddPopup() {
    this.visibleAddButton = true;
    this.visibleEditButton = false;
    [this.selectedProduct, this.selectedCountry, this.selectedLocations] = [null, null, []];
    [
      this.ccpData.productIfOthers,
      this.ccpData.manufacturedLocationCode,
      this.ccpData.locationIfOthers,
      this.ccpData.supplierName,
      this.ccpData.supplierAddress,
      this.ccpData.comments
    ] = ["", "", "", "", "", ""];
    [
      this.ccpData.batchOrLotNumber,
      this.ccpData.manufacturedDate,
      this.ccpData.expiryDate,
      this.ccpData.sampleExpectedDate,
      this.ccpData.sampleReceivedOn,
      this.ccpData.sampleReturnedOn
    ] = [null, null, null, null, null, null]
    this.ccpData.isSampleAvailable = this.ccpData.isSampleReqd = this.ccpData.sampleReturnDecision = this.ccpData.isPrimaryProduct = this.showProductIfOthers = this.showLocationIfOthers = false;
    this.operationFlag = 'ADD';
    this.warningMsg = false;
    this.popupDataTitle.title = "Add Product";
    this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
  }

  editingCcpId: any;
  openEditPopup(ccpEditingData: any, action: any) {
    this.isProcessing = true;
    this.visibleAddButton = false;
    this.visibleEditButton = action == 'Edit';
    this.operationFlag = 'EDIT';
    this.popupDataTitle.title = action == 'Edit' ? action + " Product" : ccpEditingData.PRODUCT_NAME + ' Information';
    this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
    this.editingCcpId = ccpEditingData.CCP_ID;
    this.appService.getCcDetailsByCcpId(this.editingCcpId).subscribe(async (data: any) => {

      data.manufacturedDate = data.manufacturedDate ? new Date(data.manufacturedDate) : null;
      data.expiryDate = data.expiryDate ? new Date(data.expiryDate) : null;
      data.sampleExpectedDate = data.sampleExpectedDate ? new Date(data.sampleExpectedDate) : null;
      data.sampleReceivedOn = data.sampleReceivedOn ? new Date(data.sampleReceivedOn) : null;
      data.sampleReturnedOn = data.sampleReturnedOn ? new Date(data.sampleReturnedOn) : null;

      data.isSampleAvailable = data.isSampleAvailable == "Y";
      data.isSampleReqd = data.isSampleReqd == "Y";
      data.sampleReturnDecision = data.sampleReturnDecision == "Y";
      data.isPrimaryProduct = data.isPrimaryProduct == "Y";

      if (data.productId) {
        const matchingProduct = this.dropDownForProduct.find((item: any) => item.productId == data.productId);

        if (!matchingProduct) {
          this.oddProduct = data.productId;
          this.productDropDown.push({
            valueExp: data.productId,
            displayExp: data.productName
          })
        }

        this.selectedProduct = data.productId;
        await this.onProductSelect(this.event, { valueExp: data.productId, displayExp: data.productName });

        this.showProductIfOthers = data.productName.toLowerCase() == 'others';
        if (data.country && data.productName.toLowerCase() != 'others') {
          const matchingCountry = this.dropDownForCountry.find((item: any) => item.codelistCode == data.country);
          if (!matchingCountry) {
            this.oddCountry = data.country;
            this.countryDropDown.push({
              valueExp: data.country,
              displayExp: data.country
            })
          }
          this.selectedCountry = data.country;
          this.onCountrySelect(this.event, { valueExp: data.country });
        }

        if (data.manufacturedLocationCode && data.productName.toLowerCase() != 'others') {
          const matchingLocations: [] = data?.manufacturedLocationCode?.split(',')?.map((splittedLocationCode: any) => this.listOfLocationsFromLocationMaster?.find((location: any) => location.locationCode == splittedLocationCode));

          if (matchingLocations.length > 0) {
            this.selectedLocations = matchingLocations?.map((location: any) => location.locationCode)
            this.showLocationIfOthers = this.selectedLocations?.find((location: any) => 'others' == location.toLowerCase());
          }
        }
      }

      this.ccpData = data;
      this.isProcessing = false;
    })
  }

  deletingCcpId: any;
  openDeletePopup(ccpDeletingData: any) {
    this.operationFlag = 'DELETE';
    this.popupDataTitle.title = "Delete Product";
    this.deletingCcpId = ccpDeletingData.CCP_ID;
    this.ccpData.deleteReason = '';
    this.visibleDeletePopup = this.dialog.open(this.deletePopup, this.deletePopupConfig);
  }

  addAndEditFunction(ccpData: any) {

    const validations = [
      { condition: (!this.selectedProduct && !this.ccpData.productIfOthers), id: 'product-validation' }
    ]

    const invalidIds = validations.filter((validation) => validation.condition).map((validation) => validation.id);

    if (invalidIds.length > 0) {
      this.fieldValidation(invalidIds);
      this.visibleMandatoryPopup = this.dialog.open(this.mandatoryPopup, this.mandatoryPopupConfig);
    } else {
      this.isProcessing = true;
      let data = {
        ccNo: this.qmsService.activityId,
        productId: this.selectedProduct ?? null,
        productIfOthers: ccpData.productIfOthers,
        country: this.showProductIfOthers ? ccpData.country : this.selectedCountry ?? null,
        locationIfOthers: ccpData.locationIfOthers,
        isPrimaryProduct: ccpData.isPrimaryProduct ? "Y" : "N",
        supplierName: ccpData.supplierName,
        supplierAddress: ccpData.supplierAddress,
        batchOrLotNumber: ccpData.batchOrLotNumber,
        manufacturedDate: ccpData.manufacturedDate ? this.appService.dateZoneConvertion(new Date(ccpData.manufacturedDate)) : null,
        expiryDate: ccpData.expiryDate ? this.appService.dateZoneConvertion(new Date(ccpData.expiryDate)) : null,
        isSampleReqd: ccpData.isSampleReqd ? "Y" : "N",
        isSampleAvailable: ccpData.isSampleAvailable ? "Y" : "N",
        sampleExpectedDate: ccpData.sampleExpectedDate ? this.appService.dateZoneConvertion(new Date(ccpData.sampleExpectedDate)) : null,
        sampleReceivedOn: ccpData.sampleReceivedOn ? this.appService.dateZoneConvertion(new Date(ccpData.sampleReceivedOn)) : null,
        sampleReturnDecision: ccpData.sampleReturnDecision ? "Y" : "N",
        sampleReturnedOn: ccpData.sampleReturnedOn ? this.appService.dateZoneConvertion(new Date(ccpData.sampleReturnedOn)) : null,
        manufacturedLocationCode: this.showProductIfOthers ? ccpData.manufacturedLocationCode : this.selectedLocations?.join(','),
        comments: ccpData.comments
      }

      if (this.operationFlag == 'ADD') {
        this.appService.createCcProduct(data).subscribe({
          next: (Response: any) => {
            if (Response.resultType == "S") {
              this.ngOnInit();
              this.visibleAddAndEditPopup.close();
              this.showSnackBar(Response.result, Response.resultType);
            } else {
              this.isProcessing = false;
            }
          },
          error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
      } else {
        const modifiedData = {
          ...data,
          ccpId: this.editingCcpId
        }
        this.appService.updateCcProduct(modifiedData).subscribe({
          next: (Response: any) => {
            if (Response.resultType == "S") {
              this.ngOnInit();
              this.visibleAddAndEditPopup.close();
              this.showSnackBar(Response.result, Response.resultType);
            } else {
              this.isProcessing = false;
            }
          },
          error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
      }
    }
  }

  cancelAddAndEditFunction() {
    this.visibleAddAndEditPopup.close();
  }

  deleteFunction(ccpData: any) {
    if (this.ccpData.deleteReason) {
      this.isProcessing = true;

      let data = {
        ccpId: this.deletingCcpId,
        deleteReason: ccpData.deleteReason
      }

      this.appService.deleteCcProduct(data).subscribe({
        next: (Response: any) => {
          if (Response.resultType == "S") {
            this.ngOnInit();
            this.visibleDeletePopup.close();
            this.showSnackBar(Response.result, Response.resultType);
          } else {
            this.isProcessing = false;
          }
        },
        error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });
    } else {
      const field = document.getElementById('delete-reason-validation') as HTMLInputElement;
      field.style.color = 'red';
    }
  }

  cancelDeleteFunction() {
    this.visibleDeletePopup.close();
  }

  showSnackBar(message: string, type: string) {
    const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ? this.message.breadcrumbData.thirdLevel : this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    sb.onAction().subscribe(() => {
      sb.dismiss();
    });
  }

  searchText: any;
  searchValue: any;
  _temp: any = {};
  columnLists: any = {};
  grid: any = [];
  tempGrid: any;
  makeStickyColumns: any;
  dataTypeList: any = [];
  visibleDataGrid: boolean = false;
  itemsPerPage = 5;
  currentPage = 1;
  totalPages = 0;
  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;
  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  showingRowsText = "Showing rows";
  pager: any = {};
  pagedItems: any[];
  error = '';

  getCall() {
    this.isProcessing = true;
    const data = {

      gridName: "CCP",
      groupId: 0
    }
    setTimeout(() => {
      this.isProcessing = false;
    }, 3000);
    this.appService.getDynamicGridHeaders(data).subscribe({
      next: (response: any) => {
        response.orderByClause = response.orderByClause ? response.orderByClause : "";
        this.makeStickyColumns = response.fixedFieldCnt;

        const data1: any = {

          gridName: "QMS_CCP_VW",
          tableOrViewName: response.tableOrViewName ?? "",
          columnsList: response.columnsList ?? "",
          fieldLabelsList: response.fieldLabelsList ?? "",
          invisibleColumn: response.invisibleColumn ?? "",
          orderByClause: response.orderByClause ?? "",
          fieldSizeList: response.fieldSizeList ?? "",
          columnsListarray: [],
          fieldColumnarray: [],
          invisibleColumnarray: [],
          fieldSizeListArray: [],
          manualEntryDataFields: response.manualEntryDataFields,
          ccNo: this.message.activityId,
          clobColumnlist: response.closblist || "",
          blobColumnlist: response.bloblist || ""
        };

        this.reportObj = { ...data1, ...data };

        this.appService.getDynamicGridData(data1).subscribe({
          next: (response1: any) => {
            this.grid = response1;

            data1.columnsListarray = data1.columnsList.split(",");
            data1.fieldColumnarray = data1.fieldLabelsList.split(",");
            data1.invisibleColumnarray = data1.invisibleColumn.split(",");
            data1.fieldSizeListArray = data1.fieldSizeList.split(",");

            this.columnLists.columnsListarray = data1.columnsListarray;
            this.columnLists.fieldLabelsList = data1.fieldLabelsList;
            this.columnLists.fieldColumnarray = [];

            for (let p = 0; p < data1.fieldColumnarray.length; p++) {
              this.columnLists.fieldColumnarray.push({
                fieldColumnarray: data1.fieldColumnarray[p],
                width: data1.fieldSizeListArray[p] + 'px'
              });
            }

            this.columnLists.invisibleColumnarray = data1.invisibleColumnarray;
            this.columnLists.fieldSizeListArray = [];

            for (const element of data1.fieldSizeListArray) {
              this.columnLists.fieldSizeListArray.push(element + 'px');
            }

            for (let y = 0; y < this.columnLists.columnsListarray.length; y++) {
              for (const element of this.columnLists.invisibleColumnarray) {
                if (this.columnLists.columnsListarray[y] == element) {
                  this.columnLists.columnsListarray.splice(y, 1);
                  this.columnLists.fieldColumnarray.splice(y, 1);
                  this.columnLists.fieldSizeListArray.splice(y, 1);
                }
              }
            }

            let tableData = {
              tablename: data1.tableOrViewName
            };

            this.columnLists.columnsListarray1 = [];

            this.appService.tableFieldsDataType(tableData).subscribe({
              next: (response2: any) => {
                this.dataTypeList = response2;

                for (let m = 0; m < this.columnLists.columnsListarray.length; m++) {
                  this.columnLists.columnsListarray1.push({});
                  this.columnLists.columnsListarray1[m].columnsListarray = this.columnLists.columnsListarray[m];
                  this.columnLists.columnsListarray1[m].dataType = "textbox";
                  this.columnLists.columnsListarray1[m].width = this.columnLists.fieldSizeListArray;

                  for (const element of this.dataTypeList) {
                    if (element.columnName == this.columnLists.columnsListarray[m]) {
                      this.columnLists.columnsListarray1[m].dataType = element.fieldType;
                    }
                  }
                }

                for (const rowData of this.grid) {
                  for (const element of this.dataTypeList) {
                    if (element.fieldType === 'CHECKBOX') {
                      rowData[element.columnName] = rowData[element.columnName] === 'Y';
                    }
                  }
                }

                this.calculateTotalPages = this.collectionSize / this.perPage;
                this.pager.totalPages = undefined;
                this.setPage(1, 0);
                this.dynamicLabelCall();
              }
            });

            this.message.gridList = this.grid;
            this.collectionSize = this.grid.length;
            this.totalPages = Math.ceil(this.grid.length / this.itemsPerPage);
            this.isProcessing = false;
          },
          error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });

        this.isProcessing = false;
      },
      error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  setPage(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(this.grid.length, page, this.perPage, targetpage);
    this.pagedItems = this.grid.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  setPagedorserch(page: number, targetpage: number) {
    if (Number.isNaN(page)) {
      page = 1;
    }

    if (this.tempGrid.length > 0) {
      this.pager = this.paginationService.getPager(this.tempGrid.length, page, this.perPage, targetpage);
      this.pagedItems = this.tempGrid.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = [];
    }
  }

  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }

  applyFilter3(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems = this.grid.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.grid.filter((item: any) =>
        item[column]?.toLowerCase().includes(filter)
      );
    }
  }


  searchValue2: any;
  applyFilter2(event: Event) {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.tempGrid = this.grid;
      this.pager = this.paginationService.getPager(this.tempGrid.length, 1, this.perPage, 0);
      this.pagedItems = this.tempGrid.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      if (this.grid == undefined) {
        return this.grid;
      }
      if (!this.grid.length) {
        return this.grid;
      }
      if (filter) {
        this.tempGrid = this.grid.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase().includes(filter);
        });
      } else {
        this.tempGrid = this.grid.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase();
        });
      }
      this.setPagedorserch(1, 0);
    }
  }

  sortedColumn: string = '';
  sortDirection: string = 'asc';
  sortColumn(column: string, list: any) {
    if (column === this.sortedColumn) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortedColumn = column;
      this.sortDirection = 'asc';
    }
    list.showsort = this.sortDirection;

    this.grid.sort((a: { [x: string]: any; }, b: { [x: string]: any; }) => {
      const key = column;
      const valueA = a[key];
      const valueB = b[key];

      if (valueA < valueB) {
        return this.sortDirection === 'asc' ? -1 : 1;
      } else if (valueA > valueB) {
        return this.sortDirection === 'asc' ? 1 : -1;
      } else {
        return 0;
      }
    });
    this.setPage(1, 0);
  }

  counts: any;
  cssfunction(ix: number) {
    let elements1 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-col1');
    let index1 = 1;
    let headerWidth = 0;
    elements1.forEach((header: any, key: any) => {
      for (let i = 1; i <= this.makeStickyColumns; i++) {
        if (index1 == i) {
          header.style.position = 'sticky';
          header.style.background = 'white';
          if (index1 > 1) {
            headerWidth += 200;
            header.style.left = headerWidth + 'px';
          } else {
            headerWidth = 60;
            header.style.left = headerWidth + 'px';
          }
        }
      }
      index1++;
    })

    let elements2 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-row1');
    let index2 = 1;
    let lengthOfColumns = this.columnLists.columnsListarray1.length;
    let colWidth = 0;
    let p = 1;
    elements2.forEach((column: any, key: any) => {
      for (let j = 1; j <= this.makeStickyColumns; j++) {
        if (index2 == j) {
          column.style.position = 'sticky';
          p = p + 1;
          column.style.background = 'white';
          column.style.textDecoration = "underline";
          column.style.color = "blue";
          column.style.cursor = "pointer";
          if (index2 > 1) {
            colWidth += 200;
            let previousColumn = elements2[key - 1];
            console.log(previousColumn.style.width);
            column.style.left = colWidth + 'px';
          } else {
            colWidth = 60;
            column.style.left = colWidth + 'px';
          }
          column.addEventListener('click', this.onClick.bind(this));
        }
      }
      if (index2 == (lengthOfColumns - 1)) {
        index2 = 0;
      } else {
        index2++;
      }
    })
  }

  onClick(event: any) {

  }

  parentCheckBox: boolean = false;
  childCheckBoxs: boolean = false;
  dataGridParentCheckBoxChecked(e: any) {
    if (e.target.checked) {
      this.childCheckBoxs = true;
      for (const element of this.grid) {
        element.childCheckBoxs = true;
      }
    } else {
      this.childCheckBoxs = false;
      for (const element of this.grid) {
        element.childCheckBoxs = false;
      }
    }
  }

  previousSelectedValue: any;
  dataGridChildCheckBoxChecked(e: any, list: any, idx: any) {
    if (e.target.checked) {
      if (this.previousSelectedValue != undefined) {
        this.grid[this.previousSelectedValue].childCheckBoxs = false;
      }
      list.childCheckBoxs = true;
    } else {
      list.childCheckBoxs = false;
    }
    this.previousSelectedValue = idx;
  }

  refreshGridData() {
    this.getCall();
  }

  @ViewChild(DynamicAuditTrailComponent) dynamicAuditTrailComponent!: DynamicAuditTrailComponent;
  auditTrail: any = {}

  openAuditTrail(viewType: any, product: any) {
    this.auditTrail.refNo = viewType == 'overAll' ? null : product.CCP_ID;
    this.auditTrail.activityRefNo = this.qmsService.activityId;
    this.auditTrail.gridName = 'CCP';
    this.auditTrail.report_And_Popup_Name = this.qmsService.moduleName + ' Products Audit Trail [' + this.qmsService.activity.ccId + ']';
    this.dynamicAuditTrailComponent.triggerTrail(product);
  }

  @ViewChild(ExcelPdfComponent) excelPdfComponent!: ExcelPdfComponent;
  excelPdf: any = {};
  reportObj: any = {};

  openReport(reportType: string) {
    this.excelPdf.reportObj = { ...this.reportObj, excludeGroupId: true };
    this.excelPdf.reportType = 'Dynamic';
    this.excelPdf.reportName = this.qmsService.moduleName + ' Products Report [' + this.qmsService.activity.ccId + ']';
    this.excelPdf.dropDown = this.columnLists?.fieldColumnarray?.map((item: any) => item.fieldColumnarray);
    this.excelPdfComponent.openReportPopup(reportType);
  }

  @ViewChild(GridReorderComponent) gridReorderComponent!: GridReorderComponent;
  openReorder() {
    this.gridReorderComponent.reordercall(this.reportObj.gridName, this.reportObj.tableOrViewName, this.qmsService.moduleName, 0)
  }

  onChildValueEmitted() {
    this.getCall();
  };

  public focusEmpty() {
    console.log();
  }
}
